import actions from '@/modules/more/store/actions'
import getters from '@/modules/more/store/getters'
import mutations from '@/modules/more/store/mutations'

export default {
  state: () => ({}),
  actions: actions,
  getters: getters,
  mutations: mutations
}
